import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgIcon } from '@ng-icons/core';
import { Confirmation } from 'primeng/api';
import { Button } from 'primeng/button';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-confirm-dialog',
  imports: [ConfirmDialog, Button, NgIcon, NgClass],
  templateUrl: './confirm-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppConfirmDialog {
  getIcon(message: Confirmation): string {
    if (message.icon) return message.icon;
    return message.acceptButtonProps?.severity === 'danger'
      ? 'matWarning'
      : 'matQuestionMark';
  }
}
